import React from 'react';
import AlertMetasearchBingForm from './MetricsMetasearch/AlertMetasearchBingForm';
import KayakAlertForm from './MetricsMetasearch/AlertMetasearchKayakForm';
import AlertGoogleHotelAdsAllTypeForm from "./MetricsMetasearch/AlertMetasearchGoogleHotelAdsAllTypeForm";
import AlertGoogleHotelAdsFblForm from "./MetricsMetasearch/AlertMetasearchGoogleHotelAdsFblForm";
import AlertGoogleHotelAdsMetaForm from "./MetricsMetasearch/AlertMetasearchGoogleHotelAdsMetaForm";
import AlertGoogleHotelAdsPpaForm from "./MetricsMetasearch/AlertMetasearchGoogleHotelAdsPpaForm";
import AlertMetasearchTripadvisorMetaForm from "./MetricsMetasearch/AlertMetasearchTripadvisorMetaForm";
import AlertMetasearchTripadvisorSpForm from "./MetricsMetasearch/AlertMetasearchTripadvisorSpForm";
import AlertMetasearchTrivagoMetaForm from "./MetricsMetasearch/AlertMetasearchTrivagoMetaForm";
import AlertMetasearchTrivagoSlForm from "./MetricsMetasearch/AlertMetasearchTrivagoSlForm";
import AlertMetasearchSkyscannerForm from "./MetricsMetasearch/AlertMetasearchSkyscannerForm";
import AlertMetasearchBudget from "./MetricsMetasearch/AlertMetasearchBudget";
import AlertGoogleSearchAdsBudget from "./MetricsMetasearch/AlertGoogleSearchAdsBudget";
import AlertDisplayAds from "./MetricsMetasearch/AlertDisplayAds";
import AlertGoogleSearchAdsCampaign from "./MetricsMetasearch/AlertGoogleSearchAdsCampaign";
import AlertPmaxCampaign from "./MetricsMetasearch/AlertPmaxCampaign";
import AlertPmaxMarket from "./MetricsMetasearch/AlertPmaxMarket";
import AlertGoogleSearchAdsMarket from "./MetricsMetasearch/AlertGoogleSearchAdsMarket";
import AlertAiConnect from "./MetricsMetasearch/AlertAiConnect";
import AlertMetasearchAllMetasearchForm from "./MetricsMetasearch/AlertMetasearchAllMetasearchForm";

const AlertManager = ({alertData, actionType, onClose, showSnackbar, refreshData }) => {

    const getAlertForm = () => {
        switch (alertData.alertType) {

            case 'ALERT_METASEARCH_BING':
                return <AlertMetasearchBingForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}
                />;

            case 'ALERT_METASEARCH_KAYAK':
                return <KayakAlertForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_GOOGLE_HOTELS_ADS':
                return <AlertGoogleHotelAdsAllTypeForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_GOOGLE_HOTELS_ADS_FBL':
                return <AlertGoogleHotelAdsFblForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_GOOGLE_HOTELS_ADS_META':
                return <AlertGoogleHotelAdsMetaForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_GOOGLE_HOTELS_ADS_PPA':
                return <AlertGoogleHotelAdsPpaForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_TRIPADVISOR_META':
                return <AlertMetasearchTripadvisorMetaForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_TRIPADVISOR_SP':
                return <AlertMetasearchTripadvisorSpForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_TRIVAGO_META':
                return <AlertMetasearchTrivagoMetaForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_TRIVAGO_SL':
                return <AlertMetasearchTrivagoSlForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_SKYSCANNER':
                return <AlertMetasearchSkyscannerForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METASEARCH_BUDGET':
                return <AlertMetasearchBudget
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_GOOGLE_SEARCH_ADS_BUDGET':
                return <AlertGoogleSearchAdsBudget
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_DISPLAY_ADS':
                return <AlertDisplayAds
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_GOOGLE_SEARCH_ADS_CAMPAIGN':
                return <AlertGoogleSearchAdsCampaign
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_PMAX_CAMPAIGN':
                return <AlertPmaxCampaign
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_PMAX_MARKET':
                return <AlertPmaxMarket
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_GOOGLE_SEARCH_ADS_MARKET':
                return <AlertGoogleSearchAdsMarket
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_AI_CONNECT':
                return <AlertAiConnect
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            case 'ALERT_METRICS_ALL_METASEARCH':
                return <AlertMetasearchAllMetasearchForm
                    alertData={alertData}
                    actionType={actionType}
                    onClose={onClose}
                    showSnackbar={showSnackbar}
                    refreshData={refreshData}/>;

            default:
                return <p>Type d'alerte non supporté.</p>;
        }
    };

    return (
        <div>
            {getAlertForm()}
        </div>
    );
};

export default AlertManager;
